import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterYearSearchValueObject extends ValueObject {
  #year

  constructor({year}) {
    super()
    this.#year = year
  }

  static create({year}) {
    return new FilterYearSearchValueObject({year: FilterRangeSearchValueObject.create(year)})
  }

  static createWithDefaultValue({config, year}) {
    const {DEFAULT_YEAR_SEARCH} = config.get('searchFilters')

    return new FilterYearSearchValueObject({
      year: FilterRangeSearchValueObject.create({
        from: year?.from || DEFAULT_YEAR_SEARCH.from,
        to: year?.to || DEFAULT_YEAR_SEARCH.to
      })
    })
  }

  static createQueryParams({config, year}) {
    const {DEFAULT_YEAR_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterYearSearchValueObject({
      year: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.YEAR].from,
          value: year?.from || DEFAULT_YEAR_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.YEAR].to,
          value: year?.to || DEFAULT_YEAR_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#year.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#year.from.isEmpty && {...this.#year.from.queryParam}),
      ...(!this.#year.to.isEmpty && {...this.#year.to.queryParam})
    }
  }

  get value() {
    return this.#year.value
  }

  toJSON() {
    return {
      year: this.#year.toJSON()
    }
  }
}
